import service from "../providers/service.js";
import { tokenize } from "../helpers/token.js";
import { setErrors } from "./error.js";
import { SET_USER_CALENDAR_ENTRIES, SET_COMPANY_CALENDAR_ENTRIES } from "./types";
import { messageOnSend } from './chat/messageActions.js';

/**
 * Fetch all entries for user by id
 * @param {number} userId 
 */
export function fetchCalendarEntriesForUser(userId) {
  return dispatch => {
    service
      .get(tokenize(`/api/calendar/user/${userId}`))
      .then(response => {
        dispatch(setCalendarEntries(response.data.entries));
      }).catch(err => {
        console.log(err);
      })
  }
}

/**
 * Create entry for user on backend
 * 
 * @param {number} userId 
 * @param {object} entryData 
 */
export function createEntryForUser(userId, entryData) {
  return (dispatch) => {
    const config = { headers: { 'Content-Type': 'json' } };

    service
      .post(tokenize(`/api/calendar`), entryData, config)
      .then(response => {
        if (response.data.message === 'calendar_entries.success') {
          dispatch(fetchCalendarEntriesForUser(userId));
        }

        if (response.data.entry && response.data.entry.users.length > 0) {
          const users = response.data.entry.users.map(u => u.id);
          for (const userId of users) {
            dispatch(messageOnSend({
              to: userId,
              seen: false,
              type: 'calendar',
              eventId: response.data.entry.id,
              message: `You've been tagged in an event! Click here to jump to calendar!`,
              latestTime: new Date()
            }));
          }
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch((err) => {
        console.log(err);
      })
  };
}

/**
 * Tag users for entry
 * 
 * @param {number} entryId 
 * @param {array} users
 */
export function tagUsersForEntry(entryId, users) {
  return (dispatch, getState) => {
    const config = { headers: { 'Content-Type': 'json' } };

    service
      .post(tokenize(`/api/calendar/${entryId}/tag-users`), { users }, config)
      .then(response => {
        if (response.data.message === 'calendar_entries.success') {
          dispatch(fetchCalendarEntriesForUser(getState().auth.currentUser.id));
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch((err) => {
        console.log(err);
      })
  };
}

/**
 * Delete calendar entry by id
 * @param {number} userId
 * @param {number} entryId 
 */
export function deleteCalendarEntry(userId, entryId) {
  return dispatch => {
    service
      .post(tokenize(`/api/calendar/${entryId}/destroy`))
      .then(response => {
        if (response.data.message === 'calendar_entries.success') {
          dispatch(fetchCalendarEntriesForUser(userId))
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

/**
 * Fetch all entries for company by id
 * @param {number} companyId
 */
export function fetchCalendarEntriesForCompany(companyId) {
  return dispatch => {
    service
      .get(tokenize(`/api/calendar/company/${companyId}`))
      .then(response => {
        dispatch(setCalendarEntries(response.data.entries, 'company'));
      }).catch(err => {
        console.log(err);
      })
  }
}

/**
 * Save entries to redux store
 * @param {array} entries 
 * @param {string} type 
 */
export function setCalendarEntries(entries, type = 'user') {
  return {
    type: type === 'user' ? SET_USER_CALENDAR_ENTRIES : SET_COMPANY_CALENDAR_ENTRIES,
    entries: entries
  };
}


// WEBPACK FOOTER //
// ./src/actions/calendar-entries.js